import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { Accordion, Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { State } from 'redux/initialState';

import { getLocalizedValue } from 'utils/getLocalizedValue';

type Props = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const DEFAULT_LABEL = 'Home';

const CustomLandingMenu: FC<Props> = ({ order, societyId, isActive }) => {
  const { t, i18n } = useTranslate();
  const history = useHistory();

  const customLandingLabel = useSelector((state: State) => {
    const customLanding =
      state.society?.actualSociety?.configuration?.customLanding;
    return customLanding?.menuLabel ?? customLanding?.title;
  });

  const menuLabel =
    getLocalizedValue(customLandingLabel, i18n.language) || DEFAULT_LABEL;

  const goToCustomLandingPage = () => {
    history.push(`/home/${societyId}`);
  };

  return (
    <Accordion.Toggle as={Button} variant="link" eventKey={order}>
      <li
        className={`nk-menu-item ${isActive ? 'active' : ''}`}
        onClick={goToCustomLandingPage}
      >
        <a className="nk-menu-link">
          <span className="nk-menu-icon">
            <em className="icon ni ni-home" />
          </span>
          <span className="nk-menu-text">{t(menuLabel)}</span>
        </a>
      </li>
    </Accordion.Toggle>
  );
};

export default CustomLandingMenu;
